import {createReducer} from "../../common/utils/reducerUtils";

import {TAB_SELECTED, TAB_NEW,} from "./tabsConstants";

const initialState = {
    currentTab : "initHome",
};

export function selectTab(state, payload) {

    return {
        currentTab : payload.tabName,
    };
}

export function newTab(state, payload) {
    return {
        currentTab : payload.tabName,
    };
}

export default createReducer(initialState, {
    [TAB_SELECTED] : selectTab, [TAB_NEW] : newTab
});
